
































































































import { Inject, Ref, Prop, Component, Vue } from 'vue-property-decorator'
import { Action } from '@/api/model/action'
import { gsap } from 'gsap'
import { ActionAPI } from '@/api/backend-client'
import { cloneDeep } from 'lodash'

@Component
export default class ActionActions extends Vue {
    @Inject() reloadReferral: () => Promise<void>
    @Prop({ required: true }) readonly action!: Action
    @Prop({ type: Boolean, default: false }) readonly dashboard!: boolean
    @Ref() wrapper: HTMLDivElement
    visible: boolean = false
    submitting: boolean = false
    markCompleteModal: boolean = false
    markIncompleteModal: boolean = false
    value: Action = null

    created(): void {
        this.value = cloneDeep<Action>(this.action)
    }

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.wrapper, {
            opacity: 0,
        })

        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }

    modalEditAction: boolean = false
    submittingEditAction: boolean = false

    async editAction(): Promise<void> {
        this.submittingEditAction = true
        await ActionAPI.update(this.value.id, {
            ...this.value,
            completed: false,
        })
        await this.reloadReferral()
        this.submittingEditAction = false
        this.visible = false
        this.modalEditAction = false
    }

    async showEditAction(): Promise<void> {
        this.visible = false
        this.modalEditAction = true
    }

    async markActionAsComplete(): Promise<void> {
        this.submitting = true
        await ActionAPI.update(this.value.id, {
            ...this.value,
            completed: true,
        })
        await this.reloadReferral()
        this.submitting = false
        this.visible = false
        this.markCompleteModal = false
    }

    async markActionAsIncomplete(): Promise<void> {
        this.submitting = true
        await ActionAPI.update(this.value.id, {
            ...this.value,
            completed: false,
        })
        await this.reloadReferral()
        this.submitting = false
        this.visible = false
        this.markIncompleteModal = false
    }

    async deleteAction(): Promise<void> {
        if (confirm('Weet je zeker dat je deze actie wilt verwijderen?')) {
            this.submitting = true
            await ActionAPI.delete(this.value.id)
            await this.reloadReferral()
            this.submitting = false
            this.visible = false
        }
    }
}
